import React from 'react';
import {
  TableRow,
  TableCell,
  Checkbox,
  TextField,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DeleteIcon from '@mui/icons-material/Delete';
import { customComponentMap, customComponentSettings } from './employeeListCustomComponents.js';
import moment from 'moment';

function EmployeeListItemCreate({ rowData, index, columns, onChange, onDelete, productId }) {
  const renderInput = (attr, col) => {
    if (['dob', 'dateOfCoverage', 'dobOfMamber'].includes(attr)) {
      return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
             views={['year', 'month', 'day']}
            inputFormat="dd-MM-yyyy"
            value={rowData[attr] ? moment(rowData[attr], "DD-MM-YYYY").toDate() : null}
            onChange={(val) => {
              const formattedDate = val ? moment(val).format("DD-MM-YYYY") : null;
              onChange(attr, formattedDate);
            }}
            maxDate={new Date()}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                fullWidth
                style={{ minWidth: "180px" }}
              />
            )}
          />
        </LocalizationProvider>
      );
    }

    if (attr === 'gender') {
      return (
        <FormControl fullWidth size="small" style={{ minWidth: '180px' }} >
          <InputLabel>Gender</InputLabel>
          <Select
            label="Gender"
            value={rowData[attr] || ''}
            onChange={(e) => onChange(attr, e.target.value)}
          >
            <MenuItem value="Male">Male</MenuItem>
            <MenuItem value="Female">Female</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </Select>
        </FormControl>
      );
    }

    if (attr === 'relationshipForTailormade') {
      return (
        <FormControl fullWidth size="small">
          <InputLabel>{col.title || col.sumInsuredHeader.title || attr}</InputLabel>
          <Select
            style={{ minWidth: '180px' }}
            label="relationshipForTailormade"
            value={rowData[attr] || ''}
            onChange={(e) => onChange(attr, e.target.value)}
          >
            <MenuItem value={'Self'}>Self</MenuItem>
            <MenuItem value={'Spouse'}>Spouse</MenuItem>
            <MenuItem value={'Child 1'}>Child 1</MenuItem>
            <MenuItem value={'Child 2'}>Child 2 </MenuItem>
            <MenuItem value={'Child 3'}>Child 3 </MenuItem>
            <MenuItem value={'Child 4'}>Child 4 </MenuItem>
            <MenuItem value={'Child 5'}>Child 5 </MenuItem>
            <MenuItem value={'Child 6'}>Child 6 </MenuItem>
            <MenuItem value={'Child 7'}>Child 7 </MenuItem>
            <MenuItem value={'Father'}>Father</MenuItem>
            <MenuItem value={'Mother'}>Mother</MenuItem>
            <MenuItem value={'Father-in-law'}>Father-in-law</MenuItem>
            <MenuItem value={'Mother-in-law'}>Mother-in-law</MenuItem>
            <MenuItem value={'Brother'}>Brother</MenuItem>
            <MenuItem value={'Sister'}>Sister</MenuItem>
          </Select>
        </FormControl>
      );
    }

    const CustomComponent = customComponentMap[attr];
    const CustomSetting = customComponentSettings[attr];
    if (CustomComponent) {
      return (
        <CustomComponent
          tableListDatas={[rowData]}
          index={0}
          productId={productId}
          label={col.title || col.sumInsuredHeader.title || attr}
          apiUrl={CustomSetting}
          handleChange={(attr, _, value) => onChange(attr, value)}
        />
      );
    }

    return (
      <TextField
        size="small"
        style={{ minWidth: '180px' }}
        fullWidth
        type={['age', 'sumInsured', 'premium', 'topupSI'].includes(attr) ? 'number' : 'text'}
        value={rowData[attr] || ''}
        onChange={(e) => onChange(attr, e.target.value)}
      />
    );
  };

  return (
    <TableRow>
      <TableCell padding="checkbox">
        <Checkbox checked={false} disabled />
      </TableCell>
      <TableCell>{index + 1}</TableCell>
      {columns.map((col) => {
        const attr = col.sumInsuredHeader.attribute;
        return (
          <TableCell key={attr}>
            {renderInput(attr, col)}
          </TableCell>
        );
      })}
      <TableCell>
        <IconButton size="small" onClick={onDelete}>
          <DeleteIcon fontSize="small" color="error" />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}

export default EmployeeListItemCreate;
